module.exports = __webpack_public_path__ + "img/logo-m2n.3b890f04.svg";